/**
 * Closing frame handshake (RFC-1668).
 *
 * Every console execute-node request for a video node in Closing frame mode
 * (`in_mode === 'LAST_FRAME'`) carries this declared state update. An API that
 * predates Closing frame does not declare the field and rejects the request with
 * 422 `unknownStateFields` before any run is scheduled, so a Closing-frame image
 * can never be sent as an opening frame by an older backend.
 */

export const CLOSING_FRAME_MODE = 'LAST_FRAME'
export const CLOSING_FRAME_HANDSHAKE_FIELD = 'closing_frame_handshake'

export function closingFrameHandshakeStateUpdates(): Record<string, number> {
  return { [CLOSING_FRAME_HANDSHAKE_FIELD]: 1 }
}

/**
 * The state updates a node's execute request must carry, if any. `nodeType` is
 * the canvas type (`videoGenerator`) or the backend type (`video_generator`).
 */
export function videoExecuteStateUpdates(
  nodeType: string | undefined,
  mode: string | null | undefined,
): Record<string, number> | undefined {
  const isVideoGenerator = nodeType === 'videoGenerator' || nodeType === 'video_generator'
  return isVideoGenerator && mode === CLOSING_FRAME_MODE
    ? closingFrameHandshakeStateUpdates()
    : undefined
}

/** Whether an execute failure message is an older API refusing the handshake. */
export function isClosingFrameHandshakeRefusal(message: string): boolean {
  return message.includes(CLOSING_FRAME_HANDSHAKE_FIELD)
}
